export class Page {
  constructor() {
    this.page = 1;
    this.pageSize = 10;
  }
}
/**基本审批信息 */
export class ApproveBaseVO {
  constructor() {
    this.approveRemark = "";
    this.approveStatus = "";
  }
}
/**审批 */
export class ApproveVO extends ApproveBaseVO {
  constructor() {
    super();
    this.id = "";
  }
}
/**批量审批 */
export class BatchApproveVO extends ApproveBaseVO {
  constructor() {
    super();
    this.idList = [];
  }
}
/**基本新增 -- 赛事、培训班等基本信息 */
export class BasePlanVO {
  constructor() {
    /**详细地址 */
    this.address = "";
    /**开始时间 */
    this.beginDateTime = "";
    /**城市 */
    this.city = "";
    /**联系人 */
    this.contactPerson = "";
    /**联系方式 */
    this.contactPhone = "";
    /**结束时间 */
    this.endDateTime = "";
    /**经费 */
    this.funds = "";
    /**总局拨付经费 */
    this.countryFunds = "";
    /**省市配套经费 */
    this.provinceFunds = "";
    /**邮箱 */
    this.mail = "";
    /*名称 */
    this.name = "";
    /**所属单位 -- 系统管理员必须上传,其余不用上传 */
    this.orgId = "";
    /**人员数量 */
    this.personNum = "";
    /**省份 */
    this.province = "";
  }
}
